/** Deterministic Guids for NegativeReasonsParameter (EtlGuid: NegativeReasonsParameter:{legacyId}). */
export const NegativeReasonParameterGuids = {
  ucretBeklentisi: "e31855d7-0caf-5802-86cd-fb301fa39c8f", // 1
  calismaSekli: "62a493e6-c632-56aa-b2d9-40fda495f15c", // 2
  lokasyon: "a7ab1125-71e4-5b33-9ca8-9af7c07d5cef", // 3
  sektor: "bce3b48f-2162-5f39-b72d-d13fbaf1caf1", // 4
  teknikYetkinlik: "b14e9967-966f-57b2-8e25-4d9764c1d210", // 5
  calismaModeli: "3ef97496-5ba9-5887-a626-8e30aabfaea3", // 6
  yurtdisi: "a18165a6-a0b8-537d-b3de-ef04409840b3", // 7
  firmayiDegerlendirmiyor: "6ecd0e6f-ffff-57d0-a875-5841ed70a4be", // 8
  onceOlumsuz: "6435bb49-c9c1-5236-b23d-5f54024a7f89", // 9
  farkliIk: "22fbc2a6-acd2-5558-bf2f-167fa48f4b5d", // 10
  zamTerfi: "60f448cb-de77-500a-9832-423cd0927dda", // 11
  askerlikDogum: "b3702736-4c16-5ee7-805b-cec16dc6a762", // 12
  egitim: "e59e7be0-00ba-5761-9531-d306fdad737f", // 13
  davranisIletisim: "f165a8fc-04f3-5009-b9ea-2faa2af45510", // 14
  firmasindanMemnun: "bada0e18-38e3-5714-8b76-4f35459cc6bd", // 15
  kisiselNedenler: "1cf0f331-21f7-5fb0-b407-13861cfaed01", // 16
} as const;

const N = NegativeReasonParameterGuids;
const R = (ids: (keyof typeof N)[]) => ids.map((k) => N[k]);

/** Alt durum Guid → ilgili olumsuz neden Guid listesi (legacy kategori haritası). */
export const negativeReasonIdsBySubcase: Record<string, string[]> = {
  // SubStatusParameterGuids.ikGorusme1
  "45696629-0fd1-52cd-8c96-9e46e58a52c4": R([
    "ucretBeklentisi",
    "teknikYetkinlik",
    "davranisIletisim",
    "askerlikDogum",
    "lokasyon",
    "egitim",
  ]),
  // ikGorusme2
  "76f4fb3f-e187-5608-9d39-7c2e6d68f7e3": R([
    "ucretBeklentisi",
    "teknikYetkinlik",
    "davranisIletisim",
    "askerlikDogum",
    "lokasyon",
    "egitim",
  ]),
  // telGorusme
  "91f36bd8-7e1e-5dc3-8f3e-a96c47050a2a": R([
    "firmasindanMemnun",
    "ucretBeklentisi",
    "calismaSekli",
    "lokasyon",
    "sektor",
    "teknikYetkinlik",
    "calismaModeli",
    "yurtdisi",
    "firmayiDegerlendirmiyor",
    "onceOlumsuz",
    "farkliIk",
    "zamTerfi",
    "askerlikDogum",
    "egitim",
    "kisiselNedenler",
    "davranisIletisim",
  ]),
  // linkedin
  "a04b5f1e-a317-56a5-bd98-a228c68ed2de": R([
    "firmasindanMemnun",
    "ucretBeklentisi",
    "calismaSekli",
    "lokasyon",
    "sektor",
    "teknikYetkinlik",
    "calismaModeli",
    "yurtdisi",
    "firmayiDegerlendirmiyor",
    "onceOlumsuz",
    "farkliIk",
    "zamTerfi",
    "askerlikDogum",
    "egitim",
    "davranisIletisim",
  ]),
};

/**
 * Olumsuz neden alanı YALNIZCA haritada karşılığı olan alt durumlarda gösterilir
 * ve zorunludur: LinkedIn, Tel. Görüşme, İK Görüşme 1-2.
 *
 * Upstream 5a8f50f bu kuralı TERSİNE ÇEVİRDİ: önceki hâl "şu alt durumlarda GİZLE"
 * (`subStatusNegativeReasonHidden`) idi, yani haritada olmayan her alt durumda alan
 * görünüp zorunlu oluyordu. Yeni hâl "yalnızca haritada olanlarda GÖSTER".
 */
export const isNegativeReasonSubStatus = (
  subStatusId: string | null | undefined,
): boolean =>
  !!subStatusId && negativeReasonIdsBySubcase[subStatusId] != null;
